import { useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { Loading } from '../Loading'

import { hasBootScreen, holdBootScreen, isBootScreenShown } from './bootScreen'

export const AppLoadingScreen = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const label = t('ui.loading')

  useLayoutEffect(() => holdBootScreen(label, pathname), [label, pathname])

  return hasBootScreen() ? null : <Loading />
}

export const ContentLoading = () =>
  isBootScreenShown() ? <AppLoadingScreen /> : <Loading />

export const ContinueBootScreen = () =>
  isBootScreenShown() ? <AppLoadingScreen /> : null
